module.exports = __webpack_public_path__ + "img/surfaces-screen.5c7a3ab0.jpg";